import { AppName } from 'src/global/globalConfig';
import analyticsTracking from 'src/services/analytics-service';
import useProject from 'src/shared/hooks/useProject';

const useSiteSummaryAnalytics = () => {
    const { currentProjectDetails } = useProject();

    const sendTrackEvent = (ga: { action: string; category?: string; label?: string }) => {
        analyticsTracking.trackEvent({
            ...ga,
            project: currentProjectDetails?.projectName,
            category: 'Site Summary',
            app: AppName.SITE_SUMMARY,
        });
    };

    const trackReportDownload = () => {
        sendTrackEvent({
            action: `site_summary_report_download_click`,
        });
    };

    const trackEditButtonClick = (params: { section: string }) => {
        sendTrackEvent({
            action: `site_summary_${params.section}_edit_button_click`,
        });
    };

    const trackExploreButtonClick = (params: { section: string }) => {
        sendTrackEvent({
            action: `site_summary_${params.section}_explore_button_click`,
        });
    };

    const trackOpenMapButtonClick = (params: { section: string }) => {
        sendTrackEvent({
            action: `site_summary_${params.section}_open_map_button_click`,
        });
    };

    const trackHabitatBaselineChange = (baselineYear: string) => {
        sendTrackEvent({
            action: 'site_summary_habitat_baseline_change',
            label: baselineYear,
        });
    };

    const trackLandCoverPeriodChange = (period: string) => {
        sendTrackEvent({
            action: 'site_summary_land_cover_period_change',
            label: period,
        });
    };

    const trackGoToAllFilesButtonClick = () => {
        sendTrackEvent({
            action: `site_summary_go_to_all_files_button_click`,
        });
    };

    const trackGoToAllFilesMenuOptionClick = () => {
        sendTrackEvent({
            action: `site_summary_go_to_all_files_menu_option_click`,
        });
    };

    const trackUpgradeSubscriptionClick = () => {
        sendTrackEvent({
            action: 'upgrade_subscription_button_click_from_site_summary',
        });
    };

    const trackUpgradeSubscriptionIconClick = () => {
        sendTrackEvent({
            action: 'upgrade_subscription_icon_click_from_site_summary',
        });
    };

    return {
        sendTrackEvent,
        trackReportDownload,
        trackEditButtonClick,
        trackExploreButtonClick,
        trackOpenMapButtonClick,
        trackGoToAllFilesButtonClick,
        trackGoToAllFilesMenuOptionClick,
        trackUpgradeSubscriptionClick,
        trackUpgradeSubscriptionIconClick,
        trackHabitatBaselineChange,
        trackLandCoverPeriodChange,
    };
};

export default useSiteSummaryAnalytics;
